var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLocalizacao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_854",
    d: "M18,0.5c-6.4,0-11.6,5.2-11.6,11.6c0,1.9,0.5,3.8,1.4,5.5l9.6,17.4c0.2,0.4,0.6,0.5,1,0.3 c0.1-0.1,0.2-0.2,0.3-0.3l9.6-17.4c3.1-5.7,0.9-12.7-4.7-15.8C21.8,1,19.9,0.5,18,0.5z M18,18c-3.2,0-5.8-2.6-5.8-5.8 c0-3.2,2.6-5.8,5.8-5.8c3.2,0,5.8,2.6,5.8,5.8C23.8,15.4,21.2,18,18,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocalizacao01);
export default __webpack_public_path__ + "static/media/ico-localizacao-01.35b2ff6b6bcea537cbbf3b848bb7492c.svg";
export { ForwardRef as ReactComponent };